import { useNavigate } from 'react-router';
import { Button } from '@components/atoms/Button';
import { ButtonType } from '@src/types/types';
import { Paths } from '@src/routes/paths.ts';

export function ErrorContent({
  backToProfile,
  title,
  description,
  goBack,
  errorCode,
  fullScreen = true,
}: {
  errorCode?: string;
  backToProfile: string;
  title: string;
  description: string;
  goBack?: () => void;
  fullScreen?: boolean;
}) {
  const navigate = useNavigate();
  return (
    <div
      className={`flex flex-col items-center justify-center ${fullScreen ? 'min-h-screen' : ''} bg-white px-4`}
    >
      <h1 className="text-8xl font-bold text-dark mb-4">{errorCode}</h1>
      <h2 className="font-light text-dark mb-4">{title}</h2>
      <p className="text-grey1 text-center mb-8 max-w-md">{description}</p>
      <Button
        buttonType={ButtonType.PRIMARY}
        label={backToProfile}
        onClick={
          goBack ??
          (() => {
            navigate(Paths.PROFILE);
          })
        }
        testingId="back-to-profile"
      />
    </div>
  );
}
